<template>
    <el-dialog
        :model-value="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)"
        class="submit-modal"
        width="500px"
        :show-close="false"
        center
    >
        <template #header="{ close }">
            <div class="custom-header">
                <span @click="close" class="close-text">
                    {{ $trans("web_skill_ranking.cancel") }}
                    <el-icon class="custom-close-icon"><Close /></el-icon>
                </span>
            </div>
        </template>
        <div class="modal-body-content">
            {{ $trans("web_skill_ranking.publication_confirm_message") }}
        </div>
        <template #footer>
            <div class="dialog-footer">
                <el-button
                    class="grey-button"
                    @click="$emit('update:modelValue', false)"
                >
                    {{ $trans("web_skill_ranking.cancel") }}
                </el-button>
                <el-button
                    class="blue-button"
                    type="primary"
                    @click="$emit('confirm')"
                >
                    {{ $trans("web_skill_ranking.confirm_publication") }}
                </el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import { Close } from "@element-plus/icons-vue";

export default {
    name: "SubmitRankingPublicationModal",
    components: { Close },
    props: {
        modelValue: { type: Boolean, required: true },
    },
    emits: ["update:modelValue", "confirm"],
    methods: {
        handleConfirm() {
            this.$emit("confirm");
        },
    },
};
</script>

<style scoped>
.submit-modal :deep(.el-dialog__header) {
    padding: 15px 20px 10px;
    margin-right: 0;
    border-bottom: none;
}
.submit-modal :deep(.el-dialog__body) {
    padding: 10px 30px 20px;
    font-size: 22px;
    color: #3c3c3c;
    text-align: center;
}
.modal-body-content {
    font-size: 22px;
    color: #3c3c3c !important;
}
.custom-header {
    display: flex;
    justify-content: flex-end;
    font-size: 18px;
    font-style: italic;
}
.close-text {
    cursor: pointer;
    display: flex;
    align-items: center;
}
.dialog-footer {
    display: flex;
    gap: 15px;
    width: 100%;
}
.dialog-footer .el-button {
    flex-grow: 1;
    font-size: 16px;
    padding: 18px 10px;
}
.grey-button {
    background-color: #f2f2f2;
    border-color: #f2f2f2;
    color: #606266;
}
.blue-button {
    background-color: #41abc4;
    border-color: #41abc4;
    color: white;
}

.custom-close-icon {
    font-size: 35px;
    margin-left: 10px;
    vertical-align: middle;
}
</style>
